// extracted by mini-css-extract-plugin
export default {"storyContainer":"stories_storyContainer__Ov7bB","storyCard":"stories_storyCard__Je6Ia","coverLogo":"stories_coverLogo__s50Ac"};